import React, { useContext } from 'react';
import {
  Spinner,
} from '@fluentui/react-components';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import bingAdsIcon from './bing-ads-icon.png';

const getStyles = () => ({
  sdkNoFinalUrlBlocker: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    '& svg .fui-Spinner__Tail': {
      animationDuration: '2s !important',
      animationIterationCount: 'infinite !important',
    },
  },
  blockerContent: {
    textAlign: 'center',
  },
  bingAdsIcon: {
    marginBottom: 16,
  },
});

export const SDKNoFinalUrlBlocker = () => {
  const i18n = useContext(I18nContext) as any;
  const classes = useDefaultStyles(getStyles);

  return (
    <div className={classes.sdkNoFinalUrlBlocker}>
      <div className={classes.blockerContent}>
        <img className={classes.bingAdsIcon} src={bingAdsIcon} alt={i18n.getString(_TL_('Microsoft Advertising icon'))} />
        <Spinner label={i18n.getString(_TL_('Preparing campaign creation...'))} size="medium" />
      </div>
    </div>
  );
};
